import React from 'react';
import { FieldRenderProps } from 'react-final-form';

import SFixedTextField from 'components/CustomTextInput/styled';

const InputWrapper = ({
  input,
  rest,
  placeholder,
  label,
}: FieldRenderProps<string>) => (
  <SFixedTextField
    label={label}
    placeholder={placeholder}
    {...input}
    {...rest}
  />
);

export default InputWrapper;
